import React, { Component } from "react";
import Header from "../Shared/Header";
import IconInput from "../Shared/IconInput/IconInput";
import logo from "./../../assets/image/icon.png";
import LoginService from "./Login.service";
import Cookies from "js-cookie";
import userp from "../../assets/image/icon/profile black.png";
import pwd from "../../assets/image/icon/password black.png";

import {
    EXPIRATION_DAYS_COOKIE,
    STATUS_UNPROCESSABLE_ENTITY
} from "./../../config";

import "./Login.scss";

export default class Login extends Component {
    state = {
        username: undefined,
        usernameIsInvalid: false,
        password: undefined,
        passwordIsInvalid: false,
        isLoading: false
    };

    login = () => {
        if (!this.state.username || !this.state.password) {
            let newState = {};
            if (!this.state.username)
                newState.usernameIsInvalid = "Field is required";
            if (!this.state.password)
                newState.passwordIsInvalid = "Field is required";
            this.setState(newState);
            return;
        }

        this.setState({
            isLoading: true
        });

        LoginService.login(this.state.username, this.state.password)
            .then(userInfo => {
                Cookies.set("userInfo", userInfo, {
                    expires: EXPIRATION_DAYS_COOKIE
                });
                this.props.history.push("/board");
            })
            .catch(error => {
                if (error.response.status === STATUS_UNPROCESSABLE_ENTITY) {
                    // Wrong password or user
                    this.setState({
                        passwordIsInvalid: error.response.data.error
                    });
                } else {
                    this.props.alert({
                        theme: "error",
                        message: error.message
                    });
                }
            })
            .finally(() => {
                this.setState({
                    isLoading: false
                });
            });
    };

    onKeyPress = e => {
        if (e.key === "Enter") {
            this.login();
        }
    };

    onNewUsernameValue = e => {
        if (this.state.usernameIsInvalid)
            this.setState({
                usernameIsInvalid: false
            });

        this.setState({
            username: e.target.value
        });
    };

    onNewPasswordValue = e => {
        if (this.state.passwordIsInvalid)
            this.setState({
                passwordIsInvalid: false
            });

        this.setState({
            password: e.target.value
        });
    };

    render() {
        return (
            <div>
                <Header />
                <div className="login d-flex justify-content-center align-items-center">
                    <div className="login-box d-flex flex-column justify-content-center align-items-center">
                        <div className="d-flex w-100 align-items-center mb-3">
                            <img
                                className="icon-login mb-2"
                                src={logo}
                                alt="Huckleberry logo"
                            />
                            <h1 className="ml-2">Login</h1>
                        </div>
                        <IconInput
                            isInvalid={this.state.usernameIsInvalid}
                            onValueChange={this.onNewUsernameValue}
                            onKeyPress={this.onKeyPress}
                            icon={userp}
                            type="text"
                            placeholder="Username"
                        />
                        <IconInput
                            isInvalid={this.state.passwordIsInvalid}
                            onValueChange={this.onNewPasswordValue}
                            onKeyPress={this.onKeyPress}
                            icon={pwd}
                            type="password"
                            placeholder="Password"
                        />
                        <button
                            type="button"
                            className="btn btn-primary mt-1 mb-2 w-100 btn-login"
                            id="btn-login"
                            onClick={this.login}
                            disabled={this.state.isLoading}
                        >
                            {this.state.isLoading ? (
                                <div
                                    id="btn-login-spinner"
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Log in"
                            )}
                        </button>
                        <a href="signup">Not a member yet? Sign up.</a>

                        <a href="forgotPassword">Forgot your password?</a>
                    </div>
                </div>
            </div>
        );
    }
}
